module.exports = __webpack_public_path__ + "img/PESQUISAR.0803921c.svg";